module.exports = __webpack_public_path__ + "media/images/front/life_style/3-e2bb656fb800d224032f4b3e1112fab2.jpg";